import React, { forwardRef } from 'react'
import { Icon, iconDefaultProps, IconProps } from '../Icon'

type CreditCardDownloadIconProps = IconProps

const CreditCardDownloadIcon = forwardRef<
  SVGSVGElement,
  CreditCardDownloadIconProps
>((props: CreditCardDownloadIconProps, ref) => (
  <Icon {...props} ref={ref}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="m9 17 3 3m0 0 3-3m-3 3v-7m10-4H2m3.5 9h-.3c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 16.48 2 15.92 2 14.8V7.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C3.52 4 4.08 4 5.2 4h13.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C22 5.52 22 6.08 22 7.2v7.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C20.48 18 19.92 18 18.8 18h-.3"
      fill="none"
    ></path>
  </Icon>
))

CreditCardDownloadIcon.displayName = 'CreditCardDownloadIcon'
CreditCardDownloadIcon.defaultProps = iconDefaultProps

export type { CreditCardDownloadIconProps }
export { CreditCardDownloadIcon }
